import React from "react";
import Datatable from "../../../../partials/datatable/Datatable";
import Swal from "sweetalert2";
import { InexApiService } from "../../../../services/InexApiService";
import CrudActions from "../../../../partials/datatable/CrudActions";
import AdminDropdown from "../../../../partials/content/CustomDropdowns/AdminDropdown";
import Moment from "moment";
import Loading from "../../../home/components/Loading";
import { GraduationIcon } from "../../../../components/IconsSVG";
import {
  StyledTableCell,
  StyledTableRow
} from "../../../../partials/datatable/styles";
import store from "../../../../store/store";
import { ERoles } from "../../../../enums/Roles";

const initialState = {
  trainingSubgroups: [],
  trainingGroupList: [],
  reload: false,
  loading: false
};

export default class TrainingSubgroupListing extends React.Component {
  constructor(props) {
    super(props);

    const { auth } = store.getState();
    this.auth = auth;

    this.api = new InexApiService();

    this.state = {
      ...initialState
    };

    this.handleConfirmChangeStatus = this.handleConfirmChangeStatus.bind(this);
    this.formatRow = this.formatRow.bind(this);
    this.setTrainingSubgroups = this.setTrainingSubgroups.bind(this);    
  }

  componentDidMount() {
    this.loadTrainingGroups();
  }  
  
  handleConfirmChangeStatus = async function (obj) {
    try {
      await this.api.makeHttpRequest({
        method: "PUT",
        url: `/trainingsubgroup/toggle/${obj.idTrainingSubgroup}`
      });

      this.setState({ reload: !this.state.reload });

      Swal.fire({
        title: "Sucesso!",
        text: "Status alterado com sucesso.",
        icon: "success",
        cancelButtonText: "Sair"
      });
    } catch (e) {
      Swal.fire(
        "Erro!",
        e?.response?.data ? e.response.data : "Erro ao alterar status.",
        e?.response?.data ? "warning" : "error"
      )
    }
  };

  loadTrainingGroups = async () => {
    let trainingGroupListLocal = [{value : "" , label : "TODOS" }];
    const trainingGroupListfull = await this.api.makeHttpRequest({
      url: "/traininggroup/getAllActiveTrainingGroups"
    });
    
    for (let i in trainingGroupListfull){
      trainingGroupListLocal.push({  value: trainingGroupListfull[i].idTrainingGroup, label: trainingGroupListfull[i].name })
    }

    this.setState({trainingGroupList: trainingGroupListLocal});
  };

  setTrainingSubgroups = trainingSubgroups => {
    this.setState({ trainingSubgroups });
  };

  formatRow = r => {
    let crudActions = ["toggle", "edit"];
    const isAdmin = (this.auth && this.auth.user && this.auth.user.role.type === ERoles.ADMIN);
    const isOperation = (this.auth && this.auth.user && this.auth.user.role.type === ERoles.OPERATION);

    if (isAdmin || isOperation) {
      crudActions = [...crudActions];
    }

    return (
      <StyledTableRow hover tabIndex={-1} key={r.idTrainingSubgroup}>
        {(isAdmin || isOperation) && <StyledTableCell scope="row" align="center">
          <CrudActions
            actions={crudActions}
            module="treinamento-subgrupos"
            onConfirmChangeStatus={this.handleConfirmChangeStatus}
            path={`/admin/treinamento-subgrupos/logs/${r.idTrainingSubgroup}`}
            id={r.idTrainingSubgroup}
            obj={r}
          />
        </StyledTableCell>
        }
        <StyledTableCell scope="row" align="center">
          {r.name && r.name}
        </StyledTableCell>
        <StyledTableCell scope="row" align="left">
          {r.description && r.description}
        </StyledTableCell>
        <StyledTableCell scope="row" align="center">
          {r.group && r.group}
        </StyledTableCell>
        <StyledTableCell scope="row" align="center">
          {!!r.modificationDate &&
            Moment(r.modificationDate).format("DD/MM/YYYY")}
        </StyledTableCell>
      </StyledTableRow>
    );
  };

  render() {
    window.setPageTitle("Listagem de Subgrupos de Treinamento - Admin");

    let headRows = [
      { column: "Name", label: "Nome", align: "center" },
      { column: "Description", label: "Descrição", align: "left" },
      { column: "Group", label: "Grupo", align: "center" },
      {
        column: "ModificationDate",
        label: "Data de Modificação",
        align: "center"
      }
    ];

    if (
      (this?.auth?.user && this?.auth?.user.role.type === ERoles.ADMIN)
      || (this?.auth?.user && this?.auth?.user.role.type === ERoles.OPERATION)
    ) {
      headRows = [{ label: "Ações", align: "center" }, ...headRows];
    }

    let showAdminButtons = []

    if (this.auth?.user?.role?.type === ERoles.ADMIN || this.auth?.user?.role?.type === ERoles.OPERATION) {
      showAdminButtons = [ 
        {
          label: "Adicionar",
          onClick: null,
          icone: "add",
          path: "/admin/treinamento-subgrupos/adicionar"
        } 
      ]
    }

    return (
      <>
        <Loading isLoading={this.state.loading} />
        <Datatable
          title="Subgrupos de treinamento"
          icon={GraduationIcon}
          endpoint="/trainingsubgroup/paged"
          className="h-100"
          headRows={headRows}
          trainingGroupList={this.state.trainingGroupList}
          formatRow={this.formatRow}
          rows={this.state.trainingSubgroups}
          setRows={this.setTrainingSubgroups}
          reload={this.state.reload}
          placeholderSearch="Busque por nome"
          mobile={AdminDropdown}
          width={this.props.width}
          hiddenReload
          buttons={showAdminButtons}
        />
      </>
    );
  }
}
